<template>

<div style="position: fixed; top: 0; left: 0; background: rgba(0, 0, 0, .75); color: white; font-weight: 700; padding: 7px 14px; font-size: 75%; z-index: 2000;" v-if="builder.isSaved && builder.isCp">
  Please refresh the page to reflect quote changes in the sidebar.
</div>

<QuoteWall></QuoteWall>

<div class="row content l_bg-grey l_min-headspace-mobile" :class="{ 'l_dimmed' : builder.mode == 'quote' && !builder.quoteIsViewable }" aria-live="polite" ref="builderTop">
  <div class="row-inner-full">

    <Bar
      @save-and-continue="saveAndContinue"
    ></Bar>

    <Summary></Summary>

    <button class="scrollarrow" @click="builder.scrollToRef('builderFormInner')" v-if="builder.step == 2 && builder.mode == 'build'">
      <div class="scrollarrow-circle">
        <svg class="icon"><use href="#chevron-down"></use></svg>
      </div>
    </button>

    <div class="builderframe" ref="builderFrame" v-if="!builder.requiresRecalculation">

      <div class="builderframe-main" ref="builderMain">

        <div class="content-main" ref="builderHead" role="navigation" v-if="builder.mode == 'prepare'">

          <h4 class="l_standard l_base l_no-footspace" style="margin-top:0!important; font-weight: 400;"><strong>You're almost there...</strong></h4>

        </div>

        <div class="content-main" ref="builderHead" role="navigation" v-if="builder.mode == 'build'">

          <div style="display: flex; justify-content: space-between; width: 100%;" v-if="builder.step == 1">
            <h1 class="l_standard l_base l_no-footspace" v-html="builder.range.title" v-if="builder.range"></h1>
            <button class="button l_small l_outline l_icon" data-breakmin="mama" @click.stop="builder.setMode('quote')" v-if="builder.items.length > 1 || builder.currentItem.valid">
              <span class="btn-text">Quote</span>
              <svg class="icon btn-icon"><use href="#cart"></use></svg>
            </button>
          </div>

          <!-- <div style="display: flex; justify-content: space-between; width: 100%;" v-if="builder.step > 1">
            <button class="btn-textonly" @click.stop="returnToStart()">
              <svg class="icon"><use href="#arrow-left"></use></svg>
              <span>Back to <span v-html="builder.range.itemName"></span> Selection</span>
            </button>
            <button class="button l_small l_outline l_icon" data-breakmin="mama" @click.stop="builder.setMode('quote')" v-if="builder.step > 1 || builder.items.length > 1">
              <span class="btn-text">Quote</span>
              <svg class="icon btn-icon"><use href="#cart"></use></svg>
            </button>
          </div> -->

          <!-- <hr class="builderhr"> -->

          <h4 class="l_standard l_base l_no-footspace" style="margin-top:0!important; font-weight: 400;" v-html="builder.pageTitle" v-if="builder.step > 1"></h4>

          <!-- <div class="steps" role="tabpanel" aria-label="Step Navigation" v-if="builder.step > 1 && builder.mode == 'build'">

            <template v-for="n in builder.steps">
              <button class="step" :class="{ 's_active' : builder.step == n.number, 's_complete' : builder.step > n.number, 's_clickable' : builder.step - 1 <= builder.currentItem.validStep }" v-if="n.number > 1" @click.stop="stepSet(n.number)" role="tab" aria-controls="builderFormInner" :aria-checked="builder.step == n.number">
                <div class="step-inner">
                  <span class="step-tick">
                    <svg class="icon"><use href="#check"></use></svg>
                  </span>
                  <span class="step-title"></span>
                  <span class="step-number">{{ n.title }}</span>
                </div>
              </button>
            </template>

          </div> -->

          <div class="newsteps" role="tabpanel" aria-label="Step Navigation" v-if="builder.step > 1 && builder.mode == 'build'">

            <template v-for="n in builder.steps">
              <button class="newstep" :class="{ 's_active' : builder.step == n.number, 's_complete' : builder.step > n.number, 's_clickable' : builder.step - 1 <= builder.currentItem.validStep }" @click.stop="stepSet(n.number)" role="tab" aria-controls="builderFormInner" :aria-checked="builder.step == n.number">
                <div class="newstep-inner">
                  <div class="newstep-circle">
                    <span class="newstep-tick">
                      <svg class="icon"><use href="#check"></use></svg>
                    </span>
                    <span class="newstep-number">{{ n.number }}</span>
                  </div>
                  <span class="newstep-title" v-if="n.number == 1">Type</span>
                  <span class="newstep-title" v-else>{{ n.title }}</span>
                </div>
              </button>
            </template>

            <button class="newstep" role="tab" aria-controls="builderFormInner" :aria-checked="builder.mode == 'quote'" @click.stop="gotoQuote">
              <div class="newstep-inner">
                <div class="newstep-circle">
                  <span class="newstep-tick">
                    <svg class="icon"><use href="#check"></use></svg>
                  </span>
                  <span class="newstep-number" v-html="builder.steps.length + 1"></span>
                </div>
                <span class="newstep-title">Quote</span>
              </div>
            </button>


          </div>

        </div>

        <div class="builderform" id="builderFormInner" ref="builderFormInner" :class="{ 's_loading' : builder.isSubmitted }" v-if="builder.step <= builder.stepMax">

          <!-- loading -->
          <div class="loader-screen"></div>
          <div class="loader">
            <svg class="circular-loader" viewBox="25 25 50 50" >
              <circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke="#ffffff" stroke-width="3" />
            </svg>
          </div>

          <component
            :is="mainComponent">
          </component>

        </div>

        <div class="content-main l_centered l_text-center l_headspace l_min-footspace" ref="actionsGroup">

          <!-- <div class="button-group l_stack" v-if="builder.mode == 'quote' && !builder.isCp">

            <button class="button l_icon l_base l_strong" :class="{ 's_disabled' : ( (builder.step >= builder.stepValid) || !builder.quote.deliveryType || !builder.quote.valid ) }" @click.stop="orderNow($event)">
              <span class="btn-text">Order Now</span>
              <span class="btn-icon">
                <svg class="icon"><use xlink:href="#arrow-right"></use></svg>
              </span>
            </button>

          </div> -->

          <template v-if="builder.mode == 'build' && !builder.isCp && builder.step < builder.stepMax">
            <!-- <h2>Next step</h2> -->
          </template>

          <template v-if="builder.mode == 'quote' && !builder.isCp || builder.step == builder.stepMax">
            <!-- <h2 class="l_base">Next steps</h2> -->
            <p v-html="builder.messages.nextSteps"></p>
          </template>

          <template v-if="builder.mode == 'build' && builder.isTouched && builder.stepHasErrors">
            <div ref="errorMessages" id="errorMessages">
              <p id="errorListTitle"><span v-html="builder.stepErrors.length"></span> error<span v-if="builder.stepErrors.length !== 1">s</span> found:</p>
              <ul class="buildererrorlist" aria-labelledby="errorListTitle">
                <li v-for="error in builder.stepErrors">
                  <a :href="`#${error.handle}`">
                    <span class="visually-hidden">Error: </span>
                    <span v-html="error.message"></span>
                  </a>
                </li>
              </ul>
            </div>
          </template>

        </div>

        <div class="content-main l_text-center l_no-headspace l_min-footspace" :class="{ 's_loading' : builder.isSubmitted }" v-if="builder.steps">

          <div class="button-group l_stack" v-if="builder.mode == 'build' && builder.step < builder.stepMax+1">

            <button class="button l_icon l_base l_strong" @click.stop="saveAndContinue($event)" v-if="builder.step >= 3 || (builder.currentItem.isCustom || builder.quote.isCustom)">
              <span class="btn-text" v-html="builder.steps[builder.step-1].nextText"></span>
              <span class="btn-icon">
                <svg class="icon"><use xlink:href="#arrow-right"></use></svg>
              </span>
            </button>

            <button class="button l_icon l_darkish l_strong" :class="{ 's_disabled' : builder.currentItem.validStep == 0 }" v-if="builder.mode == 'quote' && !builder.isCp" @click.stop="saveAndExit($event, 'save')">
              <span class="btn-text" v-html="builder.steps[builder.step-1].saveText"></span>
              <span class="btn-icon">
                <svg class="icon"><use xlink:href="#cross"></use></svg>
              </span>
            </button>

            <p v-if="builder.mode == 'quote' && !builder.isCp" v-html="builder.messages.saveAndLock"></p>

            <a href="/support/" target="_blank" class="button l_outline l_icon l_darkish l_strong">
              <span class="btn-text">Need help?</span>
              <span class="btn-icon">
                <svg class="icon"><use xlink:href="#help"></use></svg>
              </span>
            </a>

          </div>

          <div class="button-group l_stack" v-if="(builder.mode == 'quote' || builder.mode == 'prepare') && !builder.isCp">

            <button @click.stop="editItem($event)" class="button l_icon l_strong" v-if="builder.isKlBuilder && (!builder.quote.isCustom || builder.isCp) && builder.mode == 'quote'">
              <span class="btn-text">Edit my quote</span>
              <span class="btn-icon">
                <svg class="icon"><use xlink:href="#pencil"></use></svg>
              </span>
            </button>

            <a href="/builder/save/" class="button l_icon l_strong" v-if="(!builder.quote.isCustom || builder.isCp) && builder.mode == 'quote'">
              <span class="btn-text" v-html="builder.steps[builder.steps.length-1].saveText"></span>
              <span class="btn-icon">
                <svg class="icon"><use xlink:href="#email"></use></svg>
              </span>
            </a>

            <a href="/builder/share/" class="button l_icon l_strong" :class="{ 's_disabled' : builder.currentItem.validStep == 0 }" v-if="builder.mode == 'quote' && (!builder.quote.isCustom || builder.isCp)">
              <span class="btn-text">Share my quote</span>
              <span class="btn-icon">
                <svg class="icon"><use xlink:href="#share"></use></svg>
              </span>
            </a>

            <div v-if="builder.isKlBuilder && builder.mode == 'quote'">

              <a href="/support/design-consult/" target="_blank" class="button-with-pop button-with-pop--reverse button-with-pop--small" style="margin-top: 20px;">
                <div class="button-with-pop__inner">
                  <div class="button-with-pop__main">
                    <div class="button-with-pop__subtitle">
                      Speak to our team
                    </div>
                  </div>
                  <div class="button-with-pop__image">
                    <img src="/images/btn-speak.png" alt="">
                  </div>
                </div>
              </a>

              <a href="/products/kitchens/check-measure/" target="_blank" class="button-with-pop" style="margin-top: 20px; margin-bottom: 20px;">
                <div class="button-with-pop__inner">
                  <div class="button-with-pop__main">
                    <div class="button-with-pop__subtitle">
                      "Let's get started!"
                    </div>
                    <div class="button-with-pop__title">
                      Book <strong>Free</strong> Check Measure*
                    </div>
                    <div class="button-with-pop__icon">
                      <svg class="icon"><use href="#arrow-right"></use></svg>
                    </div>
                  </div>
                  <div class="button-with-pop__image">
                    <img src="/images/btn-ben.png" alt="">
                  </div>
                </div>
                <div class="button-with-pop__extra-text">
                  Guaranteed to fit!
                </div>
              </a>

            </div>

            <button class="button l_icon l_softred l_strong" :class="{ 's_disabled' : ( (builder.step >= builder.stepValid) || !builder.quote.deliveryType || !builder.quote.valid ) }" @click.stop="orderNow($event)">
              <span class="btn-text" v-if="builder.mode == 'prepare'">Continue to details</span>
              <span class="btn-text" v-else>Order Now</span>
              <span class="btn-icon">
                <svg class="icon"><use xlink:href="#arrow-right"></use></svg>
              </span>
            </button>

            <div class="miniquote-security l_min-footspace" style="margin-top: 0;">
              <img src="/images/payment-methods/visa.svg" alt="Visa">
              <img src="/images/payment-methods/mastercard.svg" alt="Mastercard">
              <img src="/images/payment-methods/amex.svg" alt="American Express">
            </div>

            <p v-html="builder.messages.saveAndLock" v-if="builder.mode == 'quote'"></p>

            <button class="button l_light l_icon" @click="builder.setMode('quote');" v-if="builder.mode == 'prepare'">
              <svg class="icon btn-icon"><use href="#arrow-left"></use></svg>
              <span class="btn-text">Return to quote</span>
            </button>


            <a href="/builder/new/" style="margin-top: 40px;" class="button l_light l_small l_icon" @click.prevent="startNewQuote" v-if="builder.mode == 'quote'">
              <svg class="icon btn-icon"><use href="#pencil"></use></svg>
              <span class="btn-text">Start a new quote</span>
            </a>

          </div>

        </div>

      </div>

      <div class="builderframe-aside" :class="{ 'l_quote' : builder.mode == 'quote' }" v-if="(builder.mode == 'build' && builder.step > 1) || builder.mode == 'quote'" ref="builderAside">
        <div class="builderframe-aside-inner" ref="builderSidebar">

          <Overview
            @order-now="orderNow"
            @save-and-continue="saveAndContinue"
            @save-and-exit="saveAndExit">
          </Overview>

        </div>
      </div>

    </div>

    <div class="builderframe" ref="builderFrame" v-else>

      <div class="builderframe-main" ref="builderMain">

        <div class="content-main l_centered l_text-center" ref="builderHead">


          <p><strong>We've updated our builder!</strong></p>

          <p>Looks like we've made some updates to our builder since this quote was first created and your quote needs to be&nbsp;refreshed.</p>

          <p><strong>Click to update your quote and continue building</strong></p>

          <div class="button-group l_stack">

            <!-- <a href="/builder/new/" class="button l_icon l_base l_strong">
              <span class="btn-text">Start a new quote</span>
              <span class="btn-icon">
                <svg class="icon"><use xlink:href="#arrow-right"></use></svg>
              </span>
            </a> -->

            <button class="button l_icon l_base l_strong" @click.stop="refreshQuote($event)">
              <span class="btn-text">Refresh quote</span>
              <span class="btn-icon">
                <svg class="icon"><use xlink:href="#arrow-right"></use></svg>
              </span>
            </button>

          </div>


        </div>

      </div>

    </div>

  </div>
</div>
</template>

<script setup>
var _ = require('lodash');
import axios from 'axios';

import { ref, watch, onMounted, reactive, computed } from 'vue'

import wardrobesMain from "@/components/builder/products/wardrobes/Main.vue";
import kitchensMain from "@/components/builder/products/kitchens/Main.vue";
import laundriesMain from "@/components/builder/products/laundries/Main.vue";

const comps = {
  wardrobesMain,
  kitchensMain,
  laundriesMain,
};

const props = defineProps([
  'rangeInit',
  'modeInit',
  'stepInit',
  'quoteInit',
  'itemInit',
  'opts',
  'steps',
  'messages',
  'token',
  'testMode',
  'env',
  'isCp',
])

// import { storeToRefs } from 'pinia'
import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();
// const { currentItem, validation } = storeToRefs(builder)

import { useLightboxStore } from "@/stores/lightbox";
import { each } from 'jquery';
const lightbox = useLightboxStore();

const mainComponent = computed(() => {
  return comps[builder.range.handle + 'Main']
})

onMounted(() => {

  // initiate quote and items
  if (!_.isEmpty(props.quoteInit)) {
    builder.quoteId = props.quoteInit.id;
    builder.$patch((state) => {
      state.quote = props.quoteInit;
    })
    if (!_.isEmpty(props.quoteInit.items)) {
      builder.$patch((state) => {
        state.items = props.quoteInit.items;
      })
    }
  }
  if (!_.isEmpty(props.itemInit)) {
    builder.setItemId(props.itemInit.id);
  }

  // initiate range
  if (!_.isEmpty(props.rangeInit)) {
    builder.$patch((state) => {
      state.range = props.rangeInit;
    })
  }

  // initiate messages
  if (!_.isEmpty(props.messages)) {
    builder.$patch((state) => {
      state.messages = props.messages;
    })
  }

  // initiate token
  if (!_.isEmpty(props.token)) {
    builder.$patch((state) => {
      state.token = props.token;
    })
  }

  // initiate test mode
  if (!_.isNull(props.testMode)) {
    builder.$patch((state) => {
      state.testMode = props.testMode;
    })
  }

  // initiate cp mode
  if (!_.isNull(props.isCp)) {
    builder.$patch((state) => {
      state.isCp = props.isCp;
    })
  }

  // initiate test mode
  if (!_.isNull(props.env)) {
    builder.$patch((state) => {
      state.env = props.env;
    })
  }

  // initiate action based on url
  builder.setMode(props.modeInit);

  // initiate step based on url
  builder.setStep(props.stepInit);

  // update url
  builder.updateUrl();

  // initiate options
  if (!_.isEmpty(props.opts)) {
    builder.opts = props.opts;
    if (!_.isUndefined(props.opts.products)) {
      builder.products = props.opts.products;
    }
    if (!_.isUndefined(props.opts.productLayouts.options)) {
      builder.productLayouts = props.opts.productLayouts;
    }
    if (!_.isUndefined(props.opts.wallSpace)) {
      builder.wallSpace = props.opts.wallSpace;
    }
    if (!_.isUndefined(props.opts.interior)) {
      builder.interior = props.opts.interior;
    }
    if (!_.isUndefined(props.opts.requireDoors)) {
      builder.requireDoors = props.opts.requireDoors;
    }
    if (!_.isUndefined(props.opts.panels)) {
      builder.panels = props.opts.panels;
    }
    if (!_.isUndefined(props.opts.panel1)) {
      builder.panel1 = props.opts.panel1;
    }
    if (!_.isUndefined(props.opts.panel2)) {
      builder.panel2 = props.opts.panel2;
    }
    if (!_.isUndefined(props.opts.panel3)) {
      builder.panel3 = props.opts.panel3;
    }
    if (!_.isUndefined(props.opts.panel4)) {
      builder.panel4 = props.opts.panel4;
    }
    if (!_.isUndefined(props.opts.frames)) {
      builder.frames = props.opts.frames;
    }
    if (!_.isUndefined(props.opts.hardware)) {
      builder.hardware = props.opts.hardware;
    }
    if (!_.isUndefined(props.opts.boards)) {
      builder.boards = props.opts.boards;
    }
    if (!_.isUndefined(props.opts.tops)) {
      builder.tops = props.opts.tops;
    }
    if (!_.isUndefined(props.opts.depths)) {
      builder.depths = props.opts.depths;
    }
    if (!_.isUndefined(props.opts.drawerTypes)) {
      builder.drawerTypes = props.opts.drawerTypes;
    }
    if (!_.isUndefined(props.opts.addRails)) {
      builder.addRails = props.opts.addRails;
    }
    if (!_.isUndefined(props.opts.addShelves)) {
      builder.addShelves = props.opts.addShelves;
    }
    if (!_.isUndefined(props.opts.hingedHeights)) {
      builder.hingedHeights = props.opts.hingedHeights;
    }
    if (!_.isUndefined(props.opts.hingedDoors)) {
      builder.hingedDoors = props.opts.hingedDoors;
    }
    if (!_.isUndefined(props.opts.corniceHeights)) {
      builder.corniceHeights = props.opts.corniceHeights;
    }
    if (!_.isUndefined(props.opts.delivery)) {
      builder.delivery = props.opts.delivery;
    }
    if (!_.isUndefined(props.opts.benchCutouts)) {
      builder.benchCutouts = props.opts.benchCutouts;
    }
    if (!_.isUndefined(props.opts.requireHandles)) {
      builder.requireHandles = props.opts.requireHandles;
    }
    if (!_.isUndefined(props.opts.handles)) {
      builder.handles = props.opts.handles;
    }
    if (!_.isUndefined(props.opts.requireDesignAppointment)) {
      builder.requireDesignAppointment = props.opts.requireDesignAppointment;
    }
    if (!_.isUndefined(props.opts.preferredContactMethod)) {
      builder.preferredContactMethod = props.opts.preferredContactMethod;
    }
    if (!_.isUndefined(props.opts.timeline)) {
      builder.timeline = props.opts.timeline;
    }
    if (!_.isUndefined(props.opts.config)) {
      builder.config = props.opts.config;
    }
    if (!_.isUndefined(props.opts.configGroup)) {
      builder.configGroup = props.opts.configGroup;
    }
    if (!_.isUndefined(props.opts.doorProfile)) {
      builder.doorProfile = props.opts.doorProfile;
    }
    if (!_.isUndefined(props.opts.panelFinish)) {
      builder.panelFinish = props.opts.panelFinish;
    }
    if (!_.isUndefined(props.opts.benchtopMaterial)) {
      builder.benchtopMaterial = props.opts.benchtopMaterial;
    }
    if (!_.isUndefined(props.opts.panelTypes)) {
      builder.panelTypes = props.opts.panelTypes;
    }
    if (!_.isUndefined(props.opts.components)) {
      builder.components = props.opts.components;
    }
    if (!_.isUndefined(props.opts.features)) {
      builder.features = props.opts.features;
    }
    if (!_.isUndefined(props.opts.description)) {
      builder.description = props.opts.description;
    }
  }

  builder.validateCurrentItem();

  axios.defaults.headers.common['Authorization'] = `Bearer ${builder.token}`;

})

// watch changes to the step and update the url
watch(() => builder.step, (newValue, oldValue) => {
  builder.updateUrl();
});

// watch changes to the mode and update the url
watch(() => builder.mode, (newValue, oldValue) => {
  builder.updateUrl();
});

// watch changes to the section and update the url
watch(() => builder.section, (newValue, oldValue) => {

  if (_.isUndefined(builder.items[builder.itemIndex].specs.sections)) builder.items[builder.itemIndex].specs.sections = [];
  if (_.isUndefined(builder.items[builder.itemIndex].specs.sections[builder.section - 1])) builder.items[builder.itemIndex].specs.sections[builder.section - 1] = {};

});

function save(e) {
  const emailValid = validateQuoteValue('email', builder.quote.email);
  const firstNameValid = validateQuoteValue('firstName', builder.quote.firstName);
  if (emailValid && firstNameValid) {
    saveCurrentItem(false, false, true);
  }
}

function saveAndContinue(e) {
  saveCurrentItem(true);
}

function saveAndExit(e) {
  saveCurrentItem(false, true);
}

function saveCurrentItem(nextStep = false, exit = false, conversion = null) {
  return builder.saveCurrentItem(nextStep, exit, conversion);
}

function orderNow(e) {

let readyToOrder = false;
  if (builder.hasPrepareStep) {
    if (builder.mode == 'prepare') readyToOrder = true;
    else builder.setMode('prepare');
  } else {
    readyToOrder = true;
  }
  if (readyToOrder && !builder.isSubmitted) window.location = '/order/add/' + builder.quote.hash + '/';
  e.preventDefault();
  return false;

}

function refreshQuote(e) {

  var action = '?action=my-diy-module/quote/refresh';
  var method = 'post';

  var submitData = {
    quoteId: builder.quoteId
  };
  submitData[window.csrfTokenName] = window.csrfTokenValue;

  axios({
    url: action ? action : window.location.href,
    method: method ? method : 'post',
    data: submitData,
  })
  .then((responseObject) => {
    var response = responseObject.data;

    if (response.success) {

      setTimeout(() => {
        builder.isSubmitted = false;

        location.reload();
        parent.location.reload();

        builder.validateCurrentItem();
        builder.isSaved = true;

      }, 500);

      // console.log('Form posted successfully');
      // console.log(response.success);
      // console.log(response);

    } else if (response.errors) {

      builder.isSubmitted = false;
      // this.isSuccess = false;

      console.log('Form failed to submit');
      console.log('Field Errors', response.errors);
      console.log('Form Errors', response.formErrors);

    } else {

      builder.isSubmitted = false;

    }

  })
  .catch((error) => {

    builder.isSubmitted = false;

    console.error('Error!');
    console.error(error);

  });

}

function stepNext() {
  builder.nextStep();
}

function stepSet(num) {
  builder.setStep(num);
}

function scrollTop() {
  builder.scrollToRef('builderHead');
}

function returnToStart() {
  stepSet(1)

  setTimeout(() => {
    builder.scrollToRef('builderTop');
  }, 150);
}

function gotoQuote() {
  if (builder.quote.valid) {
    builder.setMode('quote');
  }
}

function editItem(e) {
  let submitData = {
    itemId: builder.currentItem.id
  };
  builder.actionPost('item/edit', submitData, false).then(response => {
    if (_.isObject(response)) {
      builder.isSubmitted = false;
      builder.setItemId(response.item.id);
      builder.validateCurrentItem();
      builder.setMode('build');
      builder.setStep(2);
    }
  });
  return false;
}

function startNewQuote(e) {
  if (confirm('Are you sure you want to start a new quote?')) {
    window.location.href = '/builder/' + builder.quote.range.handle + '/new/';
  }
}

// sticky sidebar
const builderFrame = ref(null);
const builderMain = ref(null);
const builderAside = ref(null);
const builderSidebar = ref(null);
window.addEventListener('scroll', function() {
  if (!_.isNull(builderSidebar.value)) {
    builderSidebar.value.setAttribute("style","display:block;width:" + builderAside.value.offsetWidth+"px");
    builderSidebar.value.style.width = builderAside.value.offsetWidth;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const builderFrameTop = builderFrame.value.getBoundingClientRect().top;
    const builderFrameBottom = builderFrame.value.getBoundingClientRect().bottom;
    const viewportTop = builderFrame.value.getBoundingClientRect().top + scrollTop - 40;
    const viewportBottom = window.innerHeight;
    const viewportHeight = viewportBottom - viewportTop;
    const builderFrameVisibleHeight = builderFrameBottom - viewportTop;
    const sidebarHeight = builderSidebar.value.offsetHeight;

    if (sidebarHeight < builderFrameVisibleHeight) {
      builderFrame.value.classList.add('fix-top-VP');
      builderFrame.value.classList.remove('flex-bottom');
    }

    if (builderFrameTop < viewportTop) {
      builderFrame.value.classList.add('fix-top-VP');
      builderFrame.value.classList.remove('flex-bottom');
    } else {
      builderFrame.value.classList.remove('fix-top-VP');
    }

    if (sidebarHeight > builderFrameVisibleHeight) {
      if (builderFrameBottom + sidebarHeight < viewportBottom) {
        builderFrame.value.classList.remove('fix-top-VP');
        builderFrame.value.classList.add('flex-bottom');
      }
    }

    if (sidebarHeight > builderFrameVisibleHeight) {
      builderFrame.value.classList.remove('fix-top-VP');
      builderFrame.value.classList.add('flex-bottom');
    }
  }
});

// init refs
const builderHead = ref(null);
const builderTop = ref(null);
const builderFormInner = ref(null);
const actionsGroup = ref(null);
builder.refs['builderFrame'] = builderFrame;
builder.refs['builderHead'] = builderHead;
builder.refs['builderTop'] = builderTop;
builder.refs['builderFormInner'] = builderFormInner;
builder.refs['actionsGroup'] = actionsGroup;
</script>
